<template>
  <div>
    <el-dialog
      title="保养记录"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
          style="width: 100%"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        >
          <el-table-column label="保养日期" prop="createTime" align="center" />

          <el-table-column label="行驶里程" prop="distance" align="center">
            <template slot-scope="scope"> {{ scope.row.distance }}KM </template>
          </el-table-column>

          <el-table-column
            label="保养或检查情况"
            prop="repairSituation"
            align="center"
            show-overflow-tooltip
          />

          <el-table-column
            label="保养或检查结果"
            prop="repairResult"
            align="center"
            show-overflow-tooltip
          />

          <el-table-column label="保养清单" prop="driverName" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="downloadFile(scope.row.repairUrl)"
                >下载</el-button
              >
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="140">
            <template slot-scope="scope">
              <el-button type="text" @click="openUpdateRepairDialog(scope.row)"
                >修改</el-button
              >
              <el-popconfirm
                title="确定删除该保养记录吗？"
                @confirm="deleteRepairSubmit(scope.row)"
              >
                <el-button
                  type="text"
                  style="color: #f56c6c; margin-left: 10px"
                  slot="reference"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-button
          type="primary"
          @click="addCarMaintenanceInfoDialogVisible = true"
          >新增保养记录</el-button
        >

        <el-button @click="closeAddCarMaintenanceInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增保养记录"
      :visible.sync="addCarMaintenanceInfoDialogVisible"
      @close="closeAddCarMaintenanceInfoDialogVisible()"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="车牌号：">
          {{ this.selectCarInfo.carNum }}
        </el-form-item>

        <el-form-item label="车辆类型：">
          {{ this.selectCarInfo.carTypeName }}
        </el-form-item>

        <el-form-item label="保养日期：">
          <el-date-picker
            v-model="repairDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="行驶里程：">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              align-content: center;
            "
          >
            <el-input
              placeholder="请输入里程"
              v-model="distance"
              style="width: 200px; margin-right: 10px"
            />
            KM
          </div>
        </el-form-item>

        <el-form-item label="保养或检查情况：">
          <el-input
            v-model="repairSituation"
            type="textarea"
            :rows="4"
            placeholder="请输入保养或检查情况"
          />
        </el-form-item>

        <el-form-item label="保养或检查结果：">
          <el-input
            v-model="repairResult"
            type="textarea"
            :rows="4"
            placeholder="请输入保养或检查结果"
          />
        </el-form-item>

        <el-form-item label="保养清单：">
          <el-upload
            class="file-uploader"
            action="#"
            :http-request="handlexlslFile"
            :show-file-list="false"
            :before-upload="beforeFileUpload"
          >
            <el-button size="medium" type="text">上传文件</el-button>
          </el-upload>

          {{ filename }}
        </el-form-item>
      </el-form>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="addRepairSubmit()">确 定</el-button>
        <el-button @click="closeAddCarMaintenanceInfoDialogVisible()"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="修改保养记录"
      :visible.sync="updateCarMaintenanceInfoDialogVisible"
      @close="closeUpdateCarMaintenanceInfoDialogVisible()"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="车牌号：">
          {{ this.selectCarInfo.carNum }}
        </el-form-item>

        <el-form-item label="车辆类型：">
          {{ this.selectCarInfo.carTypeName }}
        </el-form-item>

        <el-form-item label="保养日期：">
          <el-date-picker
            v-model="updateRepairForm.repairDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="行驶里程：">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              align-content: center;
            "
          >
            <el-input
              placeholder="请输入里程"
              v-model="updateRepairForm.distance"
              style="width: 200px; margin-right: 10px"
            />
            KM
          </div>
        </el-form-item>

        <el-form-item label="保养或检查情况：">
          <el-input
            v-model="updateRepairForm.repairSituation"
            type="textarea"
            :rows="4"
            placeholder="请输入保养或检查情况"
          />
        </el-form-item>

        <el-form-item label="保养或检查结果：">
          <el-input
            v-model="updateRepairForm.repairResult"
            type="textarea"
            :rows="4"
            placeholder="请输入保养或检查结果"
          />
        </el-form-item>

        <el-form-item label="保养清单：">
          <el-upload
            class="file-uploader"
            action="#"
            :http-request="handleUpdateFile"
            :show-file-list="false"
            :before-upload="beforeUpdateFileUpload"
          >
            <el-button size="medium" type="text">上传文件</el-button>
          </el-upload>

          {{ updateFilename || getFileName(updateRepairForm.repairUrl) }}
        </el-form-item>
      </el-form>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="updateRepairSubmit()"
          >确 定</el-button
        >
        <el-button @click="closeUpdateCarMaintenanceInfoDialogVisible()"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import {
  addRepair,
  listPageRepair,
  updateRepair,
  deleteRepair,
} from "@/api/equipmentmanagement";
import CommonFile from "@/api/common";
import CommonUtil from "@/utils/commonUtil";

export default {
  name: "CarMaintenanceInfoDialog",
  props: {
    carMaintenanceInfoDialogVisible: false,
    selectCarInfo: {},
  },
  watch: {
    carMaintenanceInfoDialogVisible(val) {
      if (val) {
        this.getlistPageRepair();
      }
    },
  },

  computed: {
    visible: {
      get() {
        return this.carMaintenanceInfoDialogVisible;
      },
      set(val) {
        if (!val) {
          this.$emit("closeEvent");
        }
      },
    },
  },
  data() {
    return {
      listLoading: false,
      dataList: [],

      addCarMaintenanceInfoDialogVisible: false,
      distance: "",
      repairDate: "",
      repairSituation: "",
      repairResult: "",
      repairUrl: "",

      filename: "",
      uploadFile: null,

      updateCarMaintenanceInfoDialogVisible: false,
      updateRepairForm: {
        id: "",
        carId: "",
        distance: "",
        repairDate: "",
        repairSituation: "",
        repairResult: "",
        repairUrl: "",
      },
      updateFilename: "",
      updateUploadFile: null,
    };
  },
  methods: {
    closeAddCarMaintenanceInfoDialog() {
      this.visible = false;
    },

    getlistPageRepair() {
      let req = {
        carId: this.selectCarInfo.carId,
        carNum: this.selectCarInfo.carNum,
        carType: this.selectCarInfo.carType,
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };

      listPageRepair(req).then((result) => {
        this.dataList = result.data.data.records;
      });
    },

    addRepairSubmit() {
      if (this.repairDate === "") {
        this.$message.error("请选择日期");
        return;
      }

      if (this.distance === "") {
        this.$message.error("请输入里程");
        return;
      }

      //上传文件
      if (this.filename.length === 0) {
        this.$message.error("请选择上传文件！");
        return;
      }

      //上传文件
      CommonFile.commonUploadFile("carmaintenance", this.uploadFile.file).then(
        (res) => {
          this.pageLoading = false;
          if (res.data.code === 200) {
            //文件上传成功

            let req = {
              carId: this.selectCarInfo.carId,
              distance: this.distance,
              repairDate: this.repairDate,
              repairSituation: this.repairSituation,
              repairResult: this.repairResult,
              repairUrl: res.data.data.filePath,
            };
            // console.log(req)
            addRepair(req).then((result) => {
              if (result.data.code === 200) {
                this.$message({ message: "提交成功", type: "success" });

                this.closeAddCarMaintenanceInfoDialogVisible();
                this.getlistPageRepair();
              } else {
                this.$message.error(result.data.message);
              }
            });
          } else {
            this.$message.error(res.data.message);
          }
        }
      );
    },
    closeAddCarMaintenanceInfoDialogVisible() {
      this.repairDate = "";
      this.distance = "";
      this.repairSituation = "";
      this.repairResult = "";
      this.uploadFile = null;
      this.filename = "";
      this.addCarMaintenanceInfoDialogVisible = false;
    },
    //上传文件
    handlexlslFile(file) {
      this.uploadFile = file;
    },
    beforeFileUpload(file) {
      this.filename = file.name;
      // console.log('文件名:', file.name);
    },
    openUpdateRepairDialog(row) {
      this.updateRepairForm = {
        id: row.id,
        carId: row.carId || this.selectCarInfo.carId,
        distance: row.distance || "",
        repairDate: row.repairDate || row.createTime || "",
        repairSituation: row.repairSituation || "",
        repairResult: row.repairResult || "",
        repairUrl: row.repairUrl || "",
      };
      this.updateFilename = "";
      this.updateUploadFile = null;
      this.updateCarMaintenanceInfoDialogVisible = true;
    },
    async updateRepairSubmit() {
      if (this.updateRepairForm.repairDate === "") {
        this.$message.error("请选择日期");
        return;
      }

      if (this.updateRepairForm.distance === "") {
        this.$message.error("请输入里程");
        return;
      }

      let repairUrl = this.updateRepairForm.repairUrl;
      if (this.updateUploadFile) {
        const uploadResult = await CommonFile.commonUploadFile(
          "carmaintenance",
          this.updateUploadFile.file
        );
        if (uploadResult.data.code !== 200) {
          this.$message.error(uploadResult.data.message);
          return;
        }
        repairUrl = uploadResult.data.data.filePath;
      }

      const req = {
        id: this.updateRepairForm.id,
        carId: this.updateRepairForm.carId,
        distance: this.updateRepairForm.distance,
        repairDate: this.updateRepairForm.repairDate,
        repairSituation: this.updateRepairForm.repairSituation,
        repairResult: this.updateRepairForm.repairResult,
        repairUrl,
      };

      updateRepair(req).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: "修改成功", type: "success" });
          this.closeUpdateCarMaintenanceInfoDialogVisible();
          this.getlistPageRepair();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
    deleteRepairSubmit(row) {
      deleteRepair({ id: row.id }).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: "删除成功", type: "success" });
          this.getlistPageRepair();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
    closeUpdateCarMaintenanceInfoDialogVisible() {
      this.updateRepairForm = {
        id: "",
        carId: "",
        distance: "",
        repairDate: "",
        repairSituation: "",
        repairResult: "",
        repairUrl: "",
      };
      this.updateFilename = "";
      this.updateUploadFile = null;
      this.updateCarMaintenanceInfoDialogVisible = false;
    },
    handleUpdateFile(file) {
      this.updateUploadFile = file;
    },
    beforeUpdateFileUpload(file) {
      this.updateFilename = file.name;
    },
    getFileName(file) {
      if (!file) {
        return "";
      }
      const pos = file.lastIndexOf("/");
      return file.substring(pos + 1);
    },
    downloadFile(file) {
      var str = file;
      // console.log(str)
      var pos = str.lastIndexOf("/"); // 找到最后一个斜杠的位置
      var pos2 = str.lastIndexOf("."); // 找到最后一个点的位置（‌文件扩展名）‌
      // 提取文件名（‌不带扩展名）‌
      var fileName = str.substring(pos + 1); // 如果要包括扩展名，‌可以省略pos2参数，‌直接使用str.substring(pos + 1);

      CommonUtil.downloadFileDefault(str, fileName);
    },
  },
  created() {},
};
</script>
